import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/CheckSmallCircle.tsx
const CheckSmallCircleIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M16.664 8.753a1 1 0 0 1 .083 1.411l-5.333 6a1 1 0 0 1-1.495 0l-2.666-3a1 1 0 0 1 1.494-1.328l1.92 2.159 4.586-5.16a1 1 0 0 1 1.411-.082Z",
		fill: props.fill || "currentColor"
	})]
}));
export { CheckSmallCircleIcon };
